/**
 * Chat Header Component
 */

import React from 'react';
import { Sparkles, History, X, ArrowLeft, ShieldCheck } from 'lucide-react';

const ChatHeader = ({ 
  language, 
  showHistory, 
  setShowHistory, 
  onClose 
}) => {
  return (
    <div className="bg-primary text-white p-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        {showHistory ? (
          <button
            onClick={() => setShowHistory(false)}
            className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
            data-testid="chatbot-back-btn"
          >
            <ArrowLeft className="w-5 h-5 text-white" />
          </button>
        ) : (
          <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-gold-400" />
          </div>
        )}
        <div>
          <h3 className="font-serif font-semibold">
            {showHistory 
              ? (language === 'pt' ? 'Histórico' : 'History')
              : (language === 'pt' ? 'Assistente ABC' : 'ABC Assistant')
            }
          </h3>
          <p className="text-xs text-white/70 flex items-center gap-1">
            {showHistory
              ? (language === 'pt' ? 'Conversas anteriores' : 'Previous conversations')
              : (
                <>
                  <ShieldCheck className="w-3 h-3" />
                  {language === 'pt' ? 'Fontes controladas' : 'Controlled sources'}
                </>
              )
            }
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {!showHistory && (
          <button 
            onClick={() => setShowHistory(true)}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors"
            data-testid="chatbot-history-btn"
            title={language === 'pt' ? 'Ver histórico' : 'View history'}
          >
            <History className="w-5 h-5" />
          </button>
        )}
        <button 
          onClick={onClose}
          className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors"
          data-testid="chatbot-close-btn"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
